
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/backend-dev",
      function () {
        return require("private-next-pages/services/backend-dev.tsx");
      }
    ]);
  